//校验规则
export default {
  notNull: {required: true, message: "不能为空", trigger: ["change", "blur"]},
  number: {message: "必须为整数", pattern: /^-?\d+$/},
  numberP: {message: "必须为正整数", pattern: /^\d+$/},
  numberM: {message: "必须为负整数", pattern: /^-\d+$/},
  float1: {message: "最多1位小数点的数字", pattern: /^-?\d{1,20}(?:\.\d{1,1})?$/},
  float2: {message: "最多2位小数点的数字", pattern: /^-?\d{1,20}(?:\.\d{1,2})?$/},
  phone: {message: "1开头的11位数字", pattern: /^1[0-9]{10}$/},
  username: {message: "4~25位字符，只能包含英文字母、数字、@、点、下划线", pattern: /^[a-zA-Z0-9_@.]{4,25}$/},
  password: {message: "8-20位，必须包含【大写字母、小写字母、数字、符号】中的3种组合", pattern: /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{8,20}$/},
};
